import { all, call, fork, put, takeEvery, takeLatest } from "typed-redux-saga";
import { Action, userManagementActions } from "./user-management-store";
import { errorActions as errorActions } from "src/components/error-viewer/error-store";
import { LoginService, Shared_CreateResumeEmailKnownStates, ContactPersonService } from "src/backend/openapi/v1";
import { ContactPersonExtendedGet } from "./user-management-types";
import { takeLeading } from "redux-saga/effects";

export function* postEmailSendloginRequest(action: ReturnType<typeof userManagementActions.postEmailSendloginRequest>) {
  try {
    yield* call(LoginService.postApiV1LoginSendloginRequestViaEmail, action.payload.email, action.payload.customerId);
    yield put(userManagementActions.setListShouldReload(true));
  } catch (error) {
    yield put(errorActions.addError(error));
    yield* put(userManagementActions.clear());
  }
}

export function* emailExistsRequest(action: ReturnType<typeof userManagementActions.emailExistsRequest>) {
  try {
    const loginModel = yield* call(LoginService.getApiV1LoginEmailExists, action.payload.email, action.payload.requestId);

    if (loginModel.publicLoginEmailKnownState === Shared_CreateResumeEmailKnownStates.EmailFoundOnPublicUser) {
      yield put(userManagementActions.emailExistsFail(true));
    } else if (loginModel.publicLoginEmailKnownState === Shared_CreateResumeEmailKnownStates.UnknownEmail) {
      yield put(userManagementActions.postEmailSendloginRequest(action.payload.email, action.payload.customerId));
    } else if (loginModel.publicLoginEmailKnownState === Shared_CreateResumeEmailKnownStates.EmailFoundOnDEKOUser) {
      yield put(userManagementActions.emailExistsFail(true));
    }
  } catch (error) {
    yield put(errorActions.addError(error));
    yield* put(userManagementActions.clear());
  } finally {
    yield put(userManagementActions.setIsSubmitting(false));
  }
}

export function* watchEmailExistsRequest() {
  yield takeLatest(Action.EmailExistsRequest, emailExistsRequest);
}
export function* watchPostEmailSendloginRequest() {
  yield takeLatest(Action.PostEmailSendloginRequest, postEmailSendloginRequest);
}

export function* getContactPersonsRequest() {
  try {
    const result: ContactPersonExtendedGet[] = yield* call(ContactPersonService.getApiV1ContactPersonExtended);

    yield put(userManagementActions.getContactPersonsSuccess(result));
  } catch (error) {
    yield put(errorActions.addError(error));
    yield* put(userManagementActions.clear());
  }
}

export function* watchGetContactPersonsRequest() {
  yield takeLatest(Action.GetContactPersonsRequest, getContactPersonsRequest);
}

export function* deleteContactPersonRequest(action: ReturnType<typeof userManagementActions.deleteContactPersonRequest>) {
  try {
    yield call(ContactPersonService.deleteApiV1ContactPerson, action.payload.contactPersonId);
    yield put(userManagementActions.setListShouldReload(true));
  } catch (error) {
    yield put(errorActions.addError(error));
  }
}

export function* watchDeleteAbsenceFollowUpStateRequest() {
  yield takeEvery(Action.DeleteContactPersonRequest, deleteContactPersonRequest);
}

export function* getContactPersonByContactPersonIdRequest(action: ReturnType<typeof userManagementActions.getContactPersonByContactPersonIdRequest>) {
  try {
    const result: ContactPersonExtendedGet = yield call(ContactPersonService.getApiV1ContactPersonPermissions, action.payload.contactPersonId);
    yield put(userManagementActions.getContactPersonByContactPersonIdSuccess(result));
  } catch (error) {
    yield put(errorActions.addError(error));
  }
}

export function* watchGetContactPersonByContactPersonIdRequest() {
  yield takeEvery(Action.GetContactPersonByContactPersonIdRequest, getContactPersonByContactPersonIdRequest);
}

export function* putContactPersonRequest(action: ReturnType<typeof userManagementActions.putContactPersonRequest>) {
  try {
    yield call(ContactPersonService.putApiV1ContactPerson, action.payload.contactPersonId, action.payload.data);
    yield put(userManagementActions.putContactPersonSuccess());
    yield put(userManagementActions.setAddEditDialogProps(undefined));
    yield put(userManagementActions.setListShouldReload(true));
  } catch (error) {
    yield put(errorActions.addError(error));
  }
}

export function* watchPutContactPersonRequest() {
  yield takeLeading(Action.PutContacPersonRequest, putContactPersonRequest);
}

export function* putContactPersonPermissionRequest(action: ReturnType<typeof userManagementActions.putContactPersonPermissionRequest>) {
  try {
    yield call(ContactPersonService.putApiV1ContactPersonPermissionReplaceAll, action.payload.contactPersonId, action.payload.data);
    yield put(userManagementActions.putContactPersonPermissionSuccess());
    yield put(userManagementActions.setListShouldReload(true));
  } catch (error) {
    yield put(errorActions.addError(error));
  }
}

export function* watchPutContactPersonPermissionRequest() {
  yield takeLeading(Action.PutContactPersonPermissionRequest, putContactPersonPermissionRequest);
}

export function* UserManagementSaga() {
  yield all([
    fork(watchEmailExistsRequest),
    fork(watchPostEmailSendloginRequest),
    fork(watchGetContactPersonsRequest),
    fork(watchDeleteAbsenceFollowUpStateRequest),
    fork(watchGetContactPersonByContactPersonIdRequest),
    fork(watchPutContactPersonRequest),
    fork(watchPutContactPersonPermissionRequest)
  ]);
}
